module.exports = __webpack_public_path__ + "img/upon-delivery.8930da32.svg";